import React, { useState, useEffect } from 'react';
import { Link, Route, Routes, useNavigate } from 'react-router-dom';
import '../SoietyBlogsAdmin/SoietyBlogAdminManagement.css';
import logo from "../Assets/Image/logos.png"
import BlogManagement from './BlogManagementComponenet/BlogManagement';
const SoietyBlogAdminManagement = () => {
  const navigate = useNavigate();
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [adminData, setAdminData] = useState(null);
  const [showProfileMenu, setShowProfileMenu] = useState(false);

  useEffect(() => {
    // Get admin data from localStorage
    const storedAdminData = localStorage.getItem('adminData');
    if (storedAdminData) {
      setAdminData(JSON.parse(storedAdminData));
    }
  }, []);

  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
  };

  const handleLogout = () => {
    // Clear localStorage
    localStorage.removeItem('adminToken');
    localStorage.removeItem('adminData');
    
    // Redirect to login
    navigate('/admin/login');
  };

  const toggleProfileMenu = () => {
    setShowProfileMenu(!showProfileMenu);
  };

  return (
    <div className="blog-admin-container">
      {/* Sidebar */}
      <aside className={`blog-admin-sidebar ${isSidebarCollapsed ? 'blog-admin-sidebar-collapsed' : ''}`}>
        <div className="blog-admin-sidebar-header">
          <div className="blog-admin-logo">
            <div className="blog-admin-logo-icon">
              <img src={logo} alt="" />
            </div>
            {!isSidebarCollapsed && <span className="blog-admin-logo-text">Ohhpro</span>}
          </div>
        </div>

        <nav className="blog-admin-nav">
          <div className="blog-admin-nav-section">
            {!isSidebarCollapsed && <span className="blog-admin-nav-title">MANAGEMENT</span>}
            <ul className="blog-admin-nav-list">
              <li className="blog-admin-nav-item blog-admin-nav-item-active">
                <Link to="/blogmanagement" className="blog-admin-nav-link">
                  <svg className="blog-admin-nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                  </svg>
                  {!isSidebarCollapsed && <span>Blog Management</span>}
                </Link>
              </li>
            </ul>
          </div>
        </nav>
      </aside>

      {/* Main Content */}
      <div className="blog-admin-main">
        {/* Top Navbar */}
        <header className="blog-admin-header">
          <div className="blog-admin-header-left">
            <button className="blog-admin-hamburger" onClick={toggleSidebar}>
              <span></span>
              <span></span>
              <span></span>
            </button>
            <h1 className="blog-admin-page-title">Blog Management</h1>
          </div>
          
          <div className="blog-admin-header-right">

            <div className="blog-admin-user-profile" onClick={toggleProfileMenu}>
              <img 
                src={adminData?.avatar || "https://i.pravatar.cc/100?img=12"} 
                alt="Admin" 
                className="blog-admin-user-avatar" 
              />
              <div className="blog-admin-user-info">
                <span className="blog-admin-user-name">{adminData?.name || 'Admin'}</span>
                <span className="blog-admin-user-role">{adminData?.role || 'Administrator'}</span>
              </div>
              <svg className="blog-admin-dropdown-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" />
              </svg>

              {/* Dropdown Menu */}
              {showProfileMenu && (
                <div className="blog-admin-profile-dropdown">
                  <div className="blog-admin-dropdown-header">
                    <img src={adminData?.avatar || "https://i.pravatar.cc/100?img=12"} alt="Admin" />
                    <div>
                      <h4>{adminData?.name || 'Admin'}</h4>
                      <p>{adminData?.email || 'admin@society.com'}</p>
                    </div>
                  </div>
                  <div className="blog-admin-dropdown-divider"></div>
                  <ul className="blog-admin-dropdown-menu">
                    <li>
                      <a href="#">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                        </svg>
                        My Profile
                      </a>
                    </li>
                    <li>
                      <a href="#">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        </svg>
                        Settings
                      </a>
                    </li>
                  </ul>
                  <div className="blog-admin-dropdown-divider"></div>
                  <button className="blog-admin-logout-btn" onClick={handleLogout}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                    </svg>
                    Logout
                  </button>
                </div>
              )}
            </div>
          </div>
        </header>

        {/* Dashboard Content - Rest of the content remains the same */}
        <div className="blog-admin-content">
           <Routes>
    <Route path='/' element={<BlogManagement/>}/>
    </Routes>
        </div>
      </div>
    </div>
  );
};

export default SoietyBlogAdminManagement;